import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminInvitationCodesPage } from "src/pages/AdminInvitationCodesPage";

export const INVITATION_CODES_DEFAULT_PAGE_SIZE = 10;

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_admin/admin/invitation-codes")({
  component: AdminInvitationCodesPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async ({ trpc }) => {
      const search = deps.q;
      const page = deps.p ?? 0;
      const pageSize = deps.ps ?? INVITATION_CODES_DEFAULT_PAGE_SIZE;

      const paginationResults = await trpc.listInvitationCodes.mutate({
        pageIndex: Number(page),
        pageSize,
        query: search || "",
      });

      return {
        data: {
          paginationResults,
          pageSize,
        },
        breadcrumb: {
          label: "Invitation codes",
          href: "/invitation-codes",
        },
      };
    });
  },
});
